var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editor-interactive-view",
      class: _vm.computedClasses,
      style: _vm.computedStyles,
    },
    [
      _vm._l(
        _vm.interactionTemplatePhotoTextModels,
        function (interactionTemplatePhotoTextModel) {
          return _c(
            "div",
            {
              key: interactionTemplatePhotoTextModel.templatePosition.id,
              class: _vm.interactionTemplatePhotoTextModelClasses(
                interactionTemplatePhotoTextModel.templatePosition
              ),
              style: _vm.interactionTemplatePhotoTextModelStyles(
                interactionTemplatePhotoTextModel.objectVars
              ),
              on: {
                click: function ($event) {
                  return _vm.onAddPhotoTextClick(
                    interactionTemplatePhotoTextModel.templatePosition
                  )
                },
              },
            },
            [
              _c("IconComponent", [
                _vm._v(
                  _vm._s(
                    interactionTemplatePhotoTextModel.templatePosition.type ===
                      "photo"
                      ? "add_photo"
                      : "add_text"
                  )
                ),
              ]),
              interactionTemplatePhotoTextModel.templatePosition.type ===
              "photo"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "editor-interactive-view-add-image-placeholder",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          !_vm.isMobile
                            ? _vm.$t(
                                "views.editorInteractive.add." +
                                  _vm.productType +
                                  ".desktop"
                              )
                            : _vm.$t(
                                "views.editorInteractive.add." +
                                  _vm.productType +
                                  ".mobile"
                              )
                        )
                      ),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass:
                        "editor-interactive-view-add-text-placeholder",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          !_vm.isMobile
                            ? _vm.$t("views.editorInteractive.add.text.desktop")
                            : _vm.$t("views.editorInteractive.add.text.mobile")
                        )
                      ),
                    ]
                  ),
            ],
            1
          )
        }
      ),
      _vm._l(_vm.interactionObjectModels, function (interactionObjectModel) {
        return _c(
          "div",
          {
            key: interactionObjectModel.object.id,
            staticClass: "editor-interactive-view-edit-object",
            class: _vm.interactionObjectModelClasses(
              interactionObjectModel.object
            ),
            style: _vm.interactionObjectModelStyles(interactionObjectModel),
            attrs: { "data-object-id": interactionObjectModel.object.id },
            on: {
              click: function ($event) {
                return _vm.onEditClick(interactionObjectModel.object)
              },
              dblclick: function ($event) {
                return _vm.onEditDoubleClick(interactionObjectModel.object)
              },
              mousedown: function ($event) {
                return _vm.onObjectMouseDown(
                  interactionObjectModel.object,
                  $event
                )
              },
              touchstart: function ($event) {
                return _vm.onObjectMouseDown(
                  interactionObjectModel.object,
                  $event
                )
              },
            },
          },
          [
            _vm.isObjectTransformable(interactionObjectModel.object)
              ? [
                  _vm.isObjectTextObject(interactionObjectModel.object) &&
                  _vm.isObjectSelected(interactionObjectModel.object)
                    ? [
                        _c("span", {
                          key: _vm.interactionTextObjectModelKey[
                            interactionObjectModel.object.id
                          ],
                          staticClass:
                            "editor-interactive-view-edit-object-text-content",
                          style: _vm.interactionTextObjectModelStyles(
                            interactionObjectModel.object
                          ),
                          attrs: {
                            contenteditable: _vm.isObjectSelected(
                              interactionObjectModel.object
                            ),
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.interactionTextObjectModelText(
                                interactionObjectModel.object
                              )
                            ),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onTextObjectContentInput(
                                interactionObjectModel.object,
                                $event
                              )
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm.isObjectEditable(interactionObjectModel.object)
                    ? _c(
                        "IconComponent",
                        {
                          staticClass:
                            "editor-interactive-view-edit-object-edit",
                          on: {
                            click: function ($event) {
                              return _vm.onObjectEditClick(
                                interactionObjectModel.object
                              )
                            },
                          },
                        },
                        [_vm._v("edit")]
                      )
                    : _vm._e(),
                  _vm.isObjectRotable(interactionObjectModel.object)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "editor-interactive-view-edit-object-rotate-container",
                        },
                        [
                          _c(
                            "IconComponent",
                            {
                              staticClass:
                                "editor-interactive-view-edit-object-rotate",
                              on: {
                                mousedown: _vm.onObjectRotateMouseDown,
                                touchstart: _vm.onObjectRotateMouseDown,
                              },
                            },
                            [_vm._v("rotate_right")]
                          ),
                          _c("div", {
                            staticClass:
                              "editor-interactive-view-edit-object-rotate-rectangle",
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isObjectDeletable(interactionObjectModel.object)
                    ? _c(
                        "IconComponent",
                        {
                          staticClass:
                            "editor-interactive-view-edit-object-delete",
                          on: {
                            click: function ($event) {
                              return _vm.onObjectDeleteClick(
                                interactionObjectModel.object
                              )
                            },
                          },
                        },
                        [_vm._v("delete")]
                      )
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "top-left"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize top-left",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "top-left"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "top-left"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "top-right"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize top-right",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "top-right"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "top-right"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "left"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize-width left",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeWidthMouseDown(
                              $event,
                              "left"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeWidthMouseDown(
                              $event,
                              "left"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "right"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize-width right",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeWidthMouseDown(
                              $event,
                              "right"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeWidthMouseDown(
                              $event,
                              "right"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "bottom-left"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize bottom-left",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "bottom-left"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "bottom-left"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.shouldShowObjectResizeHandle(
                    interactionObjectModel.object,
                    "bottom-right"
                  )
                    ? _c("div", {
                        staticClass:
                          "editor-interactive-view-edit-object-resize bottom-right",
                        on: {
                          mousedown: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "bottom-right"
                            )
                          },
                          touchstart: function ($event) {
                            return _vm.onObjectResizeMouseDown(
                              $event,
                              "bottom-right"
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      _vm.isMobile && _vm.selectedTextObjectModel
        ? _c("EditorTextOptionsView", {
            ref: "editorTextOptionsView",
            attrs: {
              canvas: _vm.computedCanvas,
              "font-models": _vm.fontModels,
              "object-model": _vm.selectedTextObjectModel,
              "offering-model": _vm.offeringModel,
            },
            on: {
              change: _vm.onEditorTextOptionsChange,
              "eye-dropper-end": _vm.onEyeDropperEnd,
              "eye-dropper-start": _vm.onEyeDropperStart,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }